export interface MenuItems {
  name: string;
  key: string;
  path: string[];
  redirect: string;
}

export const HeaderMenuByBusinessManager = [
  {
    name: 'app_overview',
    key: 'app_overview_active',
    path: [
      '/gateway/business',
      '/gateway/business/',
      '/gateway/business/home',
      '/gateway/business/home/',
    ],
    push: '/home',
    redirect: `${window.location.origin}/gateway`,
  },
  {
    name: 'all_team',
    key: 'team_active',
    path: ['/gateway/business/team', '/gateway/business/team/'],
    push: '/team',
    redirect: `${window.location.origin}/gateway/business/team`,
  },
  {
    name: 'open_scene',
    key: 'open_scene_active',
    path: [
      '/gateway/business/openscene',
      '/gateway/business/openscene/',
      '/gateway/business/openscene/create',
      '/gateway/business/openscene/create/',
    ],
    push: '/openscene',
    redirect: `${window.location.origin}/gateway/business/openscene`,
  },
  {
    name: 'company_setting',
    key: 'setting_active',
    path: ['/gateway/business/setting', '/gateway/business/setting'],
    push: '/setting',
    redirect: `${window.location.origin}/gateway/business/setting`,
  },
];
export const HeaderMenuByInterfaceManager = [
  {
    name: 'interface_overview',
    key: 'interface_overview_active',
    path: ['/gateway/home', '/gateway/home/'],
    redirect: `${window.location.origin}/gateway/home`,
  },
  {
    name: 'interface_index',
    key: 'api_manager',
    path: ['/gateway', '/gateway/', '/gateway/api_manager', '/gateway/api_manager/'],
    redirect: `${window.location.origin}/gateway/api_manager`,
  },
  {
    name: 'enumerate_manager',
    key: 'enumerate_active',
    path: ['/gateway/enumerate', '/gateway/enumerate/'],
    redirect: `${window.location.origin}/gateway/enumerate`,
  },
  {
    name: 'auto_test',
    key: 'test_active',
    path: ['/gateway/interface/autotest', '/gateway/interface/autotest/'],
    redirect: `${window.location.origin}/gateway/interface/autotest`,
  },
  {
    name: 'api_monitor',
    key: 'monitor_active',
    path: ['/gateway/interface/monitor', '/gateway/interface/monitor/'],
    redirect: `${window.location.origin}/gateway/interface/monitor`,
  },
  {
    name: 'team_setting',
    key: 'setting_active',
    path: ['/gateway/team/setting', '/gateway/team/setting/'],
    redirect: `${window.location.origin}/gateway/team/setting`,
  },
];

export const HeaderMenuByOpenScene = [
  {
    name: 'openscene_overview',
    key: 'overview_active',
    path: ['/gateway/openscene', '/gateway/openscene/'],
    redirect: `${window.location.origin}/gateway/openscene`,
  },
  {
    name: 'openscene_audit',
    key: 'audit_active',
    path: ['/gateway/openscene/audit', '/gateway/openscene/audit/',
      '/gateway/openscene/audit/create', '/gateway/openscene/audit/create/',
      '/gateway/openscene/audit/manager', '/gateway/openscene/audit/manager/'],
    redirect: `${window.location.origin}/gateway/openscene/audit`,
  },
  {
    name: 'openscene_document',
    key: 'document_active',
    path: ['/gateway/document', '/gateway/document/',
      '/gateway/document/create', '/gateway/document/create/'],
    redirect: `${window.location.origin}/gateway/document`,
  },
  {
    name: 'api_monitor',
    key: 'monitor_active',
    path: ['/gateway/openscene/monitor', '/gateway/openscene/monitor/'],
    redirect: `${window.location.origin}/gateway/openscene/monitor`,
  },
  {
    name: 'openscene_setting',
    key: 'setting_active',
    path: ['/gateway/openscene/setting', '/gateway/openscene/setting/'],
    redirect: `${window.location.origin}/gateway/openscene/setting`,
  },
];

export const IndexList = [
  'gateway/', 'gateway/home', 'gateway/home/',
];

// 需要隐藏menu的path
export const HideMenuList = [
  '/gateway/document/info', '/gateway/document/info',
  '/gateway/api_manager/diff', '/gateway/api_manager/diff/',
  '/gateway/api_manager/config', '/gateway/api_manager/config/',
];

// 需要搜索框
export const NeedSearch = [
  '/gateway/config',
];

export const RedirectUrl = `${window.location.origin}/gateway/api_manager`;

export const langMap = {
  zh: '中文',
  en: 'English',
  ja: '日本語',
};

export const AuditUrlMap = [
  '/gateway/admin/',
  '/gateway/admin/api-audit',
  '/gateway/admin/api-audit/',
  '/gateway/admin/api-audit-detail',
  '/gateway/admin/api-audit-detail/',
];

export const JoinTeamUrlMap = [
  '/gateway/team/join',
  '/gateway/team/join/',
];

export const JoinOpenSceneUrlMap = [
  '/gateway/openscene/join',
  '/gateway/openscene/join/',
];

export const DEFAULT_PAGE_SIZE = 10;
